
import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';


export enum UserNotifierProductType {
    DadosBancarios = 'Dados Bancarios',
}
export enum UserNotifierActionType {
    Visualization = 'VISUALIZACAO',
}

export class UserNotifierPayload {
    constructor(
        public cblc: string | number,
        public dateOperation: number,
        public productType: UserNotifierProductType,
        public userActionType: UserNotifierActionType,
    ) { }
}

@Injectable({ providedIn: 'root' })
export class UserNotifierService extends BackendService {

    private userActionNotifierUrl = 'checkout-notifier/v1/send-to-topic';

    /**
     * Function that sends a notification for an user action
     * @param payload user notifier payload
     */
    public sendUserNotifierIntention(payload: UserNotifierPayload) {

        try {
            if (payload.cblc.toString().indexOf('-') != -1) {
                payload.cblc = payload.cblc.toString().split('-')[0]
            }

            const options = {
                observe: "response" as 'body', // to display the full response & as 'body' for type cast
            };

            return this.toroCrmAws.post(this.userActionNotifierUrl, payload, options);
        } catch (e) {
            return observableOf(false)
        }
    }
}
